/**
 * Helper function to only warn outside of test environment.
 *
 * @param message
 */
export function warnOutsideTests(message: string) {
  if (process.env.NODE_ENV === "test") {
    return;
  }
  console.warn(message);
}

/**
 * Helper function to only warn outside of test environment.
 *
 * @param isValid
 * @param message
 */
export function maybeWarnOutsideTests(isValid: boolean, message: string) {
  if (process.env.NODE_ENV === "test" || isValid) {
    return;
  }
  console.warn(message);
}
